export var fieldType = 'checkboxList';
